(function (factory) {
  "use strict";

  // Browser globals
  factory(jQuery);
})(function ($) {
  "use strict";

  $.ui = $.ui || {};
  return $.ui.version = "1.13.3";
});
export default {};